import useAuth from '@/hooks/useAuth';

export const usePlansShouldShowTabs = () => {
  const { data } = useAuth();
  const userFeatureFlags = data?.features;
  const allLocationsWithAtLeastTrainer =
    data?.allLocationsWithAtLeastTrainer ?? [];

  const isAtLeastTrainer = allLocationsWithAtLeastTrainer.length > 0;

  const hasMultipleTrainingTabs =
    (userFeatureFlags?.plans?.enabled &&
      (!!userFeatureFlags.plans.create?.enabled ||
        !!userFeatureFlags.plans.manage?.enabled ||
        !!userFeatureFlags.quizzes?.enabled)) ??
    false;

  return isAtLeastTrainer && hasMultipleTrainingTabs;
};
